import { splitTiers } from '../lib/extract';
import { Swatch } from './Swatch';
import styles from './PaletteGrid.module.css';

interface PaletteGridProps {
  colors: string[];
  baseColor: string | null;
  onSelectBase: (color: string) => void;
}

/**
 * Dominant swatches in tiers (primary / secondary / additional). Any swatch can
 * be selected as the harmony base.
 */
export function PaletteGrid({ colors, baseColor, onSelectBase }: PaletteGridProps) {
  if (colors.length === 0) return null;
  return (
    <section aria-label="Dominant colors" className={styles.palette}>
      {splitTiers(colors).map((tier) => (
        <div key={tier.id} className={styles.tier}>
          <h2 className={styles.label}>{tier.label}</h2>
          <div className={styles.grid}>
            {tier.colors.map((color, i) => (
              <Swatch
                key={`${color}-${i}`}
                color={color}
                selected={color === baseColor}
                onSelect={onSelectBase}
              />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
